import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import "./styles/common-styles.css";
import "./styles/filters-styles.css";
import "./styles/centralised-plan/layouts.css";
import "./styles/wtf-payouts/wtf-payouts.css";
import "./styles/wtf-payouts/settlement-systems.css";
import "./styles/wtf-payouts/profit-share.css";
import "./styles/campaign/campaign.css";
import "./styles/incentive-system/incentive-systems.css";
import "./styles/payment-link/payment-link.css";
import "./styles/payment-link/payment-link.css";
import "./styles/pt/personal-training.css";
import "./styles/customize-components/date-ranger.css";
import "./styles/customize-components/global-search.css";
import PrivateRoute from "./components/auth/PrivateRoute.jsx";
import Layout from "./components/Layout.jsx";
import SuspenseWrapper from "./components/SuspenseWrapper.jsx";
// import { ACCOUNT_TYPES } from "./data/Constants.js";
import { selectIsAuth, selectToken } from "./components/auth/auth.selector.js";
import { logout } from "./redux/reducers/authSlice.js";
import ComposeVC from "./components/automation/voice-campaigns/ComposeVC.jsx";
import StaffLeaveManagement from "./pages/open-pages/StaffLeaveManagement.jsx";
import LeaveManagement from "./pages/leave-management/LeaveManagement.jsx";
import PersonalTraining from "./components/pt/PersonalTraining.jsx";
import LiveMonitoring from "./pages/live-monitoring/LiveMonitoring.jsx";
import ApprovalManager from "./pages/open-pages/ApprovalManager.jsx";
import LeadManagement from "./pages/lead-management/LeadManagement.jsx";
import LeadAnalyticsGymwise from "./pages/lead-management/LeadAnalyticsGymwise.jsx";
import GymVisitAnalytics from "./pages/analytics/GymVisitAnalytics.jsx";
import FollowupAnalyticsPage from "./pages/lead-management/FollowupAnalytics.jsx";
import LeadManagementOpen from "./pages/open-pages/LeadManagementOpen.jsx";
import FreshLeads from "./pages/lead-management/FreshLeads.jsx";
import PreSaleGymLeads from "./pages/lead-management/PreSaleGymLeads.jsx";
import AgentMapping from "./pages/campaign/AgentMapping.jsx";
import FitnessProfile from "./pages/diet/FitnessProfile.jsx";
import FollowupStatuses from "./pages/lead-management/FollowupStatuses.jsx";
import CustomerIntent from "./pages/lead-management/CustomerIntent.jsx";
import URE from "./pages/unpaid-renewal-expiring/URE.jsx";
import PMLinkOpenPage from "./pages/open-pages/PMLinkOpenPage.jsx";
import WorkoutsExercise from "./pages/workouts-new/WorkoutsExercise.jsx";
import WorkoutEquipments from "./pages/workouts-new/WorkoutEquipments.jsx";
import WorkoutPackages from "./pages/workouts-new/WorkoutPackages.jsx";
import Testimonial from "./pages/website-content/Testimonial.jsx";
import WhatsNew from "./pages/website-content/WhatsNew.jsx";
import WorkoutGoals from "./pages/website-content/WorkoutGoals.jsx";
import UREOpen from "./pages/unpaid-renewal-expiring/UREOpen.jsx";
import IncentiveCalculation from "./pages/incentive-systems/IncentiveCalculation.jsx";
import WorkoutCategories from "./pages/workouts-new/WorkoutCategories.jsx";
import RawLead from "./pages/lead-management/RawLead.jsx";
import AllTasks from "./pages/hygiene-system/AllTasks.jsx";
import HygieneCategories from "./pages/hygiene-system/HygieneCategories.jsx";
import HygieneManagement from "./pages/hygiene-system/HygieneManagement.jsx";
import GymPlans from "./pages/payment-flow/GymPlans.jsx";
import CuponRequests from "./pages/payment-flow/CuponRequests.jsx";
import Partners from "./pages/website-content/Partners.jsx";
import FranchiseLeads from "./pages/website-content/FranchiseLeads.jsx";
import CuponRequestOpen from "./pages/open-pages/CuponRequestOpen.jsx";
import CartHistory from "./pages/payment-link/CartHistory.jsx";
import Users from "./pages/users/Users.jsx";
import EnquiryFormPage from "./components/enquiry/EnquiryFormPage.jsx";
import SubscriptionDetails from "./components/subs/SubscriptionDetails.jsx";
import OnboardingCenter from "./pages-v2/onboarding/OnboardingCenter.jsx";
import ProfilePage from "./pages-v2/profile-menu/ProfilePage.jsx";
import AnalyticsPage from "./pages-v2/profile-menu/AnalyticsPage.jsx";
import SettingsPage from "./pages-v2/profile-menu/SettingsPage.jsx";
import PrivacyPage from "./pages-v2/profile-menu/PrivacyPage.jsx";
import HelpCenterPage from "./pages-v2/profile-menu/HelpCenterPage.jsx";
import { CurrencyProvider } from "./context-v2/CurrencyContext.jsx";
import WTFPayouts from "./components/payouts-wtf/WTFPayouts.jsx";
import SettlementSystem from "./components/payouts-wtf/settlement-cto/SettlementSystem.jsx";
import HomePage from "./pages-v2/home/HomePage.jsx";
import NotFound from "./pages/NotFound.jsx";
import UnAuthorized from "./pages/UnAuthorized.jsx";
import IncentiveSystem from "./components/incentive-system/IncentiveSystem.jsx";
import Plans from "./components/centralised-plan-system/Plans.jsx";
import TrainerFeedbacks from "./pages/trainer-feedback/TrainerFeedback.jsx";
import TrainerReport from "./pages/trainer-report/TrainerReport.jsx";
import TrainerBCAEvaluation from "./pages/trainer-report/TrainerBCAEvaluation.jsx";
import PaymentLink from "./pages/payment-link/PaymentLink.jsx";
import PartialPayment from "./pages/payment-link/PartialPayment";
import Subscriptions from "./pages/reports-subscription/Subscriptions";
import PTTrialTrack from "./pages/open-pages/PTTrialTrack";
import DietMeals from "./pages/diet/DietMeals";
import Ingredients from "./pages/diet/Ingredients";
import DietTimings from "./pages/diet/DietTimings";
import DietUnit from "./pages/diet/DietUnit.jsx";
import DietType from "./pages/diet/DietType";
import Dieticians from "./pages/diet/Dieticians";
import DietPackage from "./pages/diet/DietPackage.jsx";
import DietDashboard from "./pages/diet/DietDashboard";
import DietPlan from "./pages/diet/DietPlan";
import SalesExportPage from "./pages/payment-link/SalesExportPage.jsx";
import MemberPage from "./pages/member/MemberPage.jsx";
import SalesPage from "./pages/sales/SalesPage.jsx";
import Login from "./components/auth/Login.jsx";
import PTTrackOpenForm from "./pages/open-pages/PTTrackOpenForm";
import CommonOpenPage from "./pages/open-pages/CommonOpenPage.jsx";
import OpenPages from "./components/Open-pages/OpenPages.jsx";
import KeywordActions from "./components/automation/keyword/KeywordActions";
import CampaignSystem from "./pages/automation/CampaignSystem.jsx";
import JobSystem from "./pages/automation/JobSystem.jsx";
import VoiceoverSystem from "./pages/automation/VoiceoverSystem.jsx";
import CTOStats from "./pages/cto/CTOStats.jsx";
import TrainerMemberEngagement from "./pages/open-pages/TrainerMemberEngagement.jsx";
import { isTokenExpired } from "./utils/token.js";
import TMELogs from "./pages/trainer-member-engagement/TMELogs.jsx";
import PTFlow from "./components/pt/pt-flow-new/PTFlow.jsx";
import Career from "./pages/website-content/Career.jsx";
import Tv from "./pages/tv-section/tv.jsx";
import TvNotification from "./components/tv/tvNotification.jsx";
import AttendanceReport from "./pages/staff-report/AttendanceReport.jsx";
import AgreementReport from "./pages/agreement-report/agreementReport.jsx";
import LeadClosureReport from "./pages/lead-closure-report/LeadClosureReport.jsx";
import OneDayMembership from "./pages/subscription/OneDayMembership.jsx";
import OneDayMembershipOpen from "./pages/open-pages/OneDayMembershipOpen.jsx";
import MetaIntegration from "./pages/meta-integration/MetaIntegration.jsx";
import MetaSettings from "./pages/meta-settings/MetaSettings.jsx";
import OfferMapping from "./pages/offer-mapping/OfferMapping.jsx";
import AllGymOffers from "./pages/offer-mapping/AllGymOffers.jsx";
import OfferAdding from "./pages/offer-mapping/OfferAdding.jsx";
import TvMonitoringDashboard from "./pages/tv-monitoring/TvMonitoringDashboard.jsx";
import WtfBanner from "./pages/wtf-banners/WtfBanner.jsx";
import PTProspectManagement from "./pages/pt-closure/PTProspectManagement.jsx";
import PTProspectManagementOpen from "./pages/open-pages/PTProspectManagementOpen.jsx";
import DefferedPayments from "./pages/payment-flow/DefferedPayments.jsx";
import DefferedPaymentsOpen from "./pages/open-pages/DefferedPaymentsOpen.jsx";
import ExpenseManagement from "./pages/expense-management/ExpenseManagement.jsx";
import ExpenseCategories from "./pages/expense-management/ExpenseCategories.jsx";
import ExpenseProcessManagers from "./pages/expense-management/ExpenseProcessManagers.jsx";
import ExpenseManagementOpen from "./pages/open-pages/ExpenseManagementOpen.jsx";
import Refferals from "./pages/refferal/Refferals.jsx";
import FitnessCenter from "./pages/fitness-center/FitnessCenter.jsx";
import AdBlogs from "./pages/ad-blogs/AdBlogs.jsx";
import BlogCategories from "./pages/ad-blogs/BlogCategories.jsx";
import DashboardFeatures from "./pages/feature-control/DashboardFeatures.jsx";
import DashboardMenus from "./pages/feature-control/DashboardMenus.jsx";
import PageMap from "./pages/feature-control/PageMap.jsx";
import ImportMembersOpen from "./pages/open-pages/ImportMembersOpen.jsx";
import ImportMembersAdmin from "./pages/import-members/ImportMembersAdmin.jsx";
import TrainerIncentivesOpen from "./pages/open-pages/TrainerIncentivesOpen.jsx";
import PTTransfer from "./pages/pt-transfer/PTTransfer.jsx";
// import LayoutHome from "./pages/LayoutHome.jsx";
import BTLVendor from "./pages/btl-leads/BTLVendor.jsx";
import TestingNumbers from "./pages/open-pages/TestingNumbers.jsx";
import UpgradeMembership from "./pages/upgrade-membership/UpgradeMembership.jsx";
import UpgradeMembershipOpen from "./pages/upgrade-membership/UpgradeMembershipOpen.jsx";
import UpgradePtMembership from "./pages/upgrade-pt-membership/UpgradePtMembership.jsx";
import BMR from "./pages/biomax-registered-members/BMR.jsx";
// import TimeSheet from "./pages/time-sheet/TimeSheet.jsx";
import TimeSheetOpen from "./pages/time-sheet/TimeSheetOpen.jsx";
import ActiveMembers from "./pages/active-members/ActiveMembers.jsx";
import UnpaidMembers from "./pages/unpaid-members/UnpaidMembers.jsx";
import Checkins from "./pages/checkins/Checkins.jsx";
import Docs from "./pages/feature-docs/Docs.jsx";
import FDTargets from "./pages/agents-reports/FDTargets.jsx";
import DateSaleReport from "./pages/agents-reports/DateSaleReport.jsx";
import FDTrainersSale from "./pages/agents-reports/FDTrainersSale.jsx";
import TaskSOP from "./pages/agents-reports/TaskSOP.jsx";
import DocsOpen from "./pages/feature-docs/DocsOpen.jsx";
import HygineTaskFrequency from "./pages/hygiene-system/HygineTaskFrequency.jsx";
import HygineOpenForm from "./pages/hygiene-system/HygineOpenForm.jsx";
import HygineForm from "./pages/hygiene-system/HygineForm.jsx";
import HygineSubmittedTasks from "./pages/hygiene-system/HygineSubmittedTasks.jsx";
import HygineSubmittedTasksOpen from "./pages/hygiene-system/HygineSubmittedTasksOpen.jsx";
import HygineGymwise from "./pages/hygiene-system/HygineGymwise.jsx";
import HygineTaskApproval from "./pages/hygiene-system/HygineTaskApproval.jsx";
import HygineTaskApprovalOpen from "./pages/hygiene-system/HygineTaskApprovalOpen.jsx";
import HygieneCommandCenter from "./pages/hygiene-system/HygieneCommandCenter.jsx";
import OnBoardingForm from "./pages/staff-onboarding/OnBoardingForm.jsx";
import OnboardedStaff from "./pages/staff-onboarding/OnboardedStaff.jsx";
import HousekeepingOnboard from "./pages/staff-onboarding/HousekeepingOnboard.jsx";
import DashFeatureGrouping from "./pages/feature-control/DashFeatureGrouping.jsx";
import Receptionists from "./pages/receptionist-management/Receptionists.jsx";
import Training from "./pages/trainings/Training.jsx";
import DFApprovals from "./pages/payment-flow/deffered-approvals/DFApprovals.jsx";
import RecurringSubscriptions from "./pages/subscription/RecurringSubscriptions.jsx";
import TrainerPage from "./pages/trainers/TrainerPage.jsx";
import TrainersRatingPage from "./pages/trainers/TrainersRatingPage.jsx";
import Version from "./pages/version/Version.jsx";
import Gallery from "./pages/gallery/index.jsx";
import WtfBenefits from "./pages/wtf-benefits/WtfBenefits.jsx";
import Notification from "./pages/notification/Notification.jsx";
import DiscountPayments from "./pages/payment-flow/discount-payments/DiscountPayments.jsx";
import DiscountPaymentsOpen from "./pages/payment-flow/discount-payments/DiscountPaymentsOpen.jsx";
import GymCities from "./pages/gym-cities/GymCities.jsx";
import RewardSystem from "./pages/reward-system/RewardSystem.jsx";
import GymFeedback from "./pages/gym-feedback/GymFeedback.jsx";
import MetabaseLinks from "./pages/metabase/MetabaseLinks.jsx";
import DynamicLinkin from "./pages/branch-io/DynamicLinkin.jsx";
import CashVerificationPage from "./pages/cash-verification/CashVerificationPage.jsx";
import CashReports from "./pages/reports-subscription/CashReports.jsx";
import GymLandingPages from "./pages/website-content/GymLandingPages.jsx";
import GymLandingListings from "./pages/website-content/GymLandingListings.jsx";
import WebsiteTabPreference from "./pages/plans/WebsiteTabPreference.jsx";
import CentralisedPlans from "./pages/plans/CentralisedPlans.jsx";
import CentralisedPTPlans from "./pages/plans/CentralisedPTPlans.jsx";
import PtPlansManage from "./pages/pt-plans/PtPlansManage.jsx";
import PlansCategories from "./pages/plans/PlansCategories.jsx";
import AddonsCategories from "./pages/addons/AddonsCategories.jsx";
import GymTransferSystem from "./pages/transfer-system/GymTransferSystem.jsx";
import MembershipTransferSystem from "./pages/transfer-system/MembershipTransferSystem.jsx";
import Transfer from "./pages/transfer-system/Transfer.jsx";
// import AcademyCourseDetail from "./components/academy/academy-course-detail/AcademyCourseDetail.jsx";
// import CourseList from "./components/academy/academy-courses/CourseList.jsx";
import AcademyCourses from "./pages/academy/academy-courses.jsx";
import AcademyCourseSchedule from "./components/academy/academy-course-schedule/AcademyCourseSchedule.jsx";
import WtfInvestors from "./pages/wtf-investors/WtfInvestors.jsx";
import WtfTeam from "./pages/wtf-team/WtfTeam.jsx";
// import CategoryList from "./components/academy/academy-course-categories/CategoryList.jsx";
import PauseSystem from "./pages/pause-system/PauseSystem";
import PauseMembership from "./pages/pause-system/PauseMembership";
import HygieneTaskCategories from "./pages/hygiene-system/HygieneTaskCategories.jsx";
import LateCheckins from "./pages/staff-report/LateCheckins.jsx";
import GymPlansOpen from "./pages/payment-flow/GymPlansOpen.jsx";
import Triggers from "./pages/trigger-system/Triggers.jsx";
import Inventories from "./pages/trigger-system/Inventories.jsx";
import Templates from "./pages/broadcast-system/Templates.jsx";
import Variables from "./pages/broadcast-system/Variables.jsx";
import SendyLists from "./pages/broadcast-system/sendy/SendyLists.jsx";
import BroadcastTemplate from "./pages/broadcast-system/BroadcastTemplate.jsx";
import LayoutHome from "./pages/LayoutHome.jsx";
import DailyTargetPage from "./pages/home/daily-target/DailyTarget.jsx";
import FitnessProfileLogs from "./pages/fitness-profile/FitnessProfileLogs.jsx";
import HealthTracking from "./pages/fitness-profile/HealthTracking.jsx";
import BCAScheduler from "./pages/broadcast-system/BCAScheduler.jsx";
import BCAScheduledWatiLogs from "./pages/broadcast-system/BCAScheduledWatiLogs.jsx";
import LMSBeta from "./pages/lead-management/LMSBeta.jsx";
// import LeadReports from "./pages/lead-management/LeadReports.jsx";
import SegmentOfferMapping from "./pages/trigger-system/SegmentOfferMapping.jsx";
import PayroleProcessor from "./pages/payrole-system/PayroleProcessor.jsx";
import TicketSystem from "./pages/ticket-system/ticketSystem.jsx";
import TicketUserRoles from "./components/ticket-system/ticket-user-roles/TicketUserRoles.jsx";
import TicketSystemManagement from "./components/ticket-system/ticket-management/TicketSystemManagement.jsx";
import SLARules from "./components/ticket-system/ticket-SLA/SLARules.jsx";
// import RoasterManager from "./pages/payrole-system/RoasterManager.jsx";
import LMSClosureReport from "./pages/lead-closure-report/LMSClosureReport.jsx";
import ThreeDayPTTrial from "./pages/pt-closure/ThreeDayPTTrial.jsx";
import StaffProfiles from "./pages/staff-report/StaffProfiles.jsx";
import AcademyLeads from "./pages/lead-management/AcademyLeads.jsx";
import GymAlias from "./pages/gym-alias/GymAlias.jsx";
import SubscriptionExtension from "./pages/subscription-extenstion/SubscriptionExtension.jsx";
import LiveSubsciptions from "./pages/live-subscriptions/LiveSubsciptions.jsx";
import LiveBCAPending from "./pages/live-subscriptions/LiveBCAPending.jsx";
import LivePTTrialPending from "./pages/live-subscriptions/LivePTTrialPending.jsx";
// import LiveCheckin from "./pages/live-monitoring/LiveCheckin.jsx";
import LiveMemberCheckins from "./pages/live-subscriptions/LiveMemberCheckins.jsx";
import LiveMemberReport from "./pages/live-subscriptions/LiveMemberReport.jsx";
import LiveRenewalReminder from "./pages/live-subscriptions/LiveRenewalReminder.jsx";
import TrackingSystem from "./pages/tracking-system/TrackingSystem.jsx";
import FitnessCoachLeads from "./pages/fitness-coach-leads/fitnessCoachLeads.jsx";
import Regularization from "./pages/staff-report/Regularization.jsx";
import ESSLMemberDump from "./pages/essl/ESSLMemberDump.jsx";
import WTF360Consultations from "./pages/wtf-360/WTF360Consultations.jsx";
import TrainerNotificationLogs from "./pages/trainer-report/TrainerNotificationLogs.jsx";
import ChatHistory from "./components/chat-history/ChatHistory.jsx";

import AmplifyLeads from "./pages/wtf-amplify-leads/AmplifyLeads.jsx";
import FDIncentives from "./pages/incentive-systems/FDIncentives.jsx";
import CallLogs from "./pages/campaign/CallLogs.jsx";

// Email Broadcast System
import EmailBroadcastDashboard from "./pages/broadcast-system/email-broadcast/EmailBroadcastDashboard.jsx";
import EmailLists from "./pages/broadcast-system/email-broadcast/EmailLists.jsx";
import EmailSubscribers from "./pages/broadcast-system/email-broadcast/EmailSubscribers.jsx";
import EmailTemplates from "./pages/broadcast-system/email-broadcast/EmailTemplates.jsx";
import EmailCampaigns from "./pages/broadcast-system/email-broadcast/EmailCampaigns.jsx";
import EmailCampaignForm from "./pages/broadcast-system/email-broadcast/EmailCampaignForm.jsx";
import EmailAnalytics from "./pages/broadcast-system/email-broadcast/EmailAnalytics.jsx";
import EmailSuppression from "./pages/broadcast-system/email-broadcast/EmailSuppression.jsx";
import Home from "./pages/home/Home.jsx";
import UnifiedPTView from "./pages/unified-pt-view/UnifiedPTView.jsx";

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isAuthenticated = useSelector(selectIsAuth);
  const token = useSelector(selectToken);

  const handleLogout = useCallback(() => {
    // Previous logic: If user was on /open-access path, redirect back to /open-access
    // if (pathname.startsWith("/open-access")) {
    //   navigate("/open-access", { state: { from: pathname } });
    // } else {
    //   navigate("/login", { state: { from: pathname } });
    // }

    // New logic: Always redirect to /login
    navigate("/login", { state: { from: pathname } });

    dispatch(logout());
  }, [pathname, navigate, dispatch]);

  // Previous logic: /open-access paths were excluded from authentication check
  // and users could access open-access pages without login.
  // New logic: All /open-access/ paths now redirect to /login
  // const excludedPaths = [
  //   "/open-access",
  //   "/login",
  //   "/subscriptions",
  //   "/enquiry",
  //   "/daily-operation-checklist-form-open",
  //   "/staff-on-board",
  // ];

  useEffect(() => {
    // Redirect /open-access/ paths to /login
    if (pathname.startsWith("/open-access/") || pathname === "/open-access") {
      navigate("/login", { state: { from: pathname } });
      return;
    }

    const excludedPaths = [
      // "/open-access", // Commented out: Previously allowed open-access without login
      "/login",
      "/cash-verify",
      "/subscriptions",
      "/enquiry",
      "/daily-operation-checklist-form-open",
      "/staff-on-board",
    ];

    if (!excludedPaths.some((path) => pathname.startsWith(path))) {
      if (!isAuthenticated || isTokenExpired(token)) {
        handleLogout();
      }
    }
  }, [isAuthenticated, token, pathname, navigate, handleLogout]);

  useEffect(() => {
    const interval = setInterval(() => {
      console.log("TOKEN EXPIRED!");
      handleLogout();
    }, 86400000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);

        if (response.status === 401) {
          console.log("Unauthorized: Logging out");
          handleLogout();
        }

        return response;
      } catch (error) {
        console.error("Fetch error:", error);
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <CurrencyProvider>
      <Routes>
        <Route path={"/"} element={<Layout />}>
          <Route path="/" element={<LayoutHome />} />

          <Route element={<PrivateRoute path="/home" />}>
            <Route path="/home" element={<Home />} />
          </Route>

          <Route element={<PrivateRoute path="/onboarding" />}>
            <Route path="/onboarding" element={<OnboardingCenter />} />
          </Route>

          {/* Profile Menu Pages - accessible to all logged-in users */}
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/help-center" element={<HelpCenterPage />} />

        <Route element={<PrivateRoute path="/dashboard-menus" />}>
          <Route path="/dashboard-menus" element={<DashboardMenus />} />
        </Route>

        <Route element={<PrivateRoute path="/dashboard-features" />}>
          <Route path="/dashboard-features" element={<DashboardFeatures />} />
        </Route>

        <Route element={<PrivateRoute path="/dashboard-feature-map" />}>
          <Route path="/dashboard-feature-map" element={<PageMap />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-flow" />}>
          <Route path="/pt-flow" element={<PersonalTraining />} />
        </Route>

        <Route element={<PrivateRoute path="/trainers-rating" />}>
          <Route path="/trainers-rating" element={<TrainersRatingPage />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-flow-beta" />}>
          <Route path="/pt-flow-beta" element={<PTFlow />} />
        </Route>

        <Route element={<PrivateRoute path="/unified-pt-view" />}>
          <Route path="/unified-pt-view" element={<UnifiedPTView />} />
        </Route>

        <Route element={<PrivateRoute path="/incentive-system" />}>
          <Route path="/incentive-system" element={<IncentiveSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/trainer-incentives" />}>
          <Route
            path="/trainer-incentives"
            element={<IncentiveCalculation />}
          />
        </Route>

        <Route element={<PrivateRoute path="/payment-link" />}>
          <Route path="/payment-link" element={<PaymentLink />} />
        </Route>

        <Route element={<PrivateRoute path="/partial-payments" />}>
          <Route path="/partial-payments" element={<PartialPayment />} />
        </Route>

        <Route element={<PrivateRoute path="/trainer-feedback" />}>
          <Route path="/trainer-feedback" element={<TrainerFeedbacks />} />
        </Route>

        <Route element={<PrivateRoute path="/users" />}>
          <Route path="/users" element={<Users />} />
        </Route>

        <Route element={<PrivateRoute path="/biomax-registered-members" />}>
          <Route path="/biomax-registered-members" element={<BMR />} />
        </Route>

        <Route element={<PrivateRoute path="/active-members" />}>
          <Route path="/active-members" element={<ActiveMembers />} />
        </Route>

        <Route element={<PrivateRoute path="/unpaid-members" />}>
          <Route path="/unpaid-members" element={<UnpaidMembers />} />
        </Route>

        <Route element={<PrivateRoute path="/checkins" />}>
          <Route path="/checkins" element={<Checkins />} />
        </Route>

        <Route element={<PrivateRoute path="/member" />}>
          <Route path="/member" element={<MemberPage />} />
        </Route>

        <Route element={<PrivateRoute path="/subscription" />}>
          <Route path="/subscription" element={<Subscriptions />} />
        </Route>

        <Route element={<PrivateRoute path="/one-day-membership" />}>
          <Route path="/one-day-membership" element={<OneDayMembership />} />
        </Route>

        <Route element={<PrivateRoute path="/meta-integration" />}>
          <Route path="/meta-integration" element={<MetaIntegration />} />
        </Route>

        <Route element={<PrivateRoute path="/meta-settings" />}>
          <Route path="/meta-settings" element={<MetaSettings />} />
        </Route>

        <Route element={<PrivateRoute path="/sales-data" />}>
          <Route path="/sales-data" element={<SalesExportPage />} />
        </Route>

        <Route element={<PrivateRoute path="/trainer-report" />}>
          <Route path="/trainer-report" element={<TrainerReport />} />
        </Route>

        <Route element={<PrivateRoute path="/trainer-bca-evaluation" />}>
          <Route
            path="/trainer-bca-evaluation"
            element={<TrainerBCAEvaluation />}
          />
        </Route>

        <Route element={<PrivateRoute path="/agreement-report" />}>
          <Route path="/agreement-report" element={<AgreementReport />} />
        </Route>

        <Route element={<PrivateRoute path="/daily-target" />}>
          <Route path="/daily-target" element={<DailyTargetPage />} />
        </Route>

        <Route element={<PrivateRoute path="/sales/today" />}>
          <Route path="/sales/today" element={<SalesPage />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-track" />}>
          <Route path="/pt-track" element={<PTTrialTrack />} />
        </Route>

        <Route element={<PrivateRoute path="/live-monitoring" />}>
          <Route path="/live-monitoring" element={<LiveMonitoring />} />
        </Route>

        {/* <Route element={<PrivateRoute path="/live-checkin" />}>
          <Route path="/live-checkin" element={<LiveCheckin />} />
        </Route> */}

        <Route element={<PrivateRoute path="/customer-intents" />}>
          <Route path="/customer-intents" element={<CustomerIntent />} />
        </Route>

        <Route element={<PrivateRoute path="/followup-status" />}>
          <Route path="/followup-status" element={<FollowupStatuses />} />
        </Route>

        <Route
          element={<PrivateRoute path="/renewal-expiring-unpaid-members" />}
        >
          <Route path="/renewal-expiring-unpaid-members" element={<URE />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-transfer" />}>
          <Route path="/pt-transfer" element={<PTTransfer />} />
        </Route>

        {/* WORKOUTS */}
        <Route element={<PrivateRoute path="/equipments" />}>
          <Route path="/equipments" element={<WorkoutEquipments />} />
        </Route>

        <Route element={<PrivateRoute path="/workout-goals" />}>
          <Route path="/workout-goals" element={<WorkoutGoals />} />
        </Route>

        <Route element={<PrivateRoute path="/workout-categories" />}>
          <Route path="/workout-categories" element={<WorkoutCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/exercise" />}>
          <Route path="/exercise" element={<WorkoutsExercise />} />
        </Route>

        <Route element={<PrivateRoute path="/workout-packages" />}>
          <Route path="/workout-packages" element={<WorkoutPackages />} />
        </Route>
        {/* --------------- WORKOUTS ------------- */}

        <Route element={<PrivateRoute path="/gym-plans" />}>
          <Route path="/gym-plans" element={<GymPlans />} />
        </Route>

        <Route element={<PrivateRoute path="/membership-requests" />}>
          <Route path="/membership-requests" element={<CuponRequests />} />
        </Route>

        <Route element={<PrivateRoute path="/deffered-payments" />}>
          <Route path="/deffered-payments" element={<DefferedPayments />} />
        </Route>

        <Route element={<PrivateRoute path="/discount-payments" />}>
          <Route path="/discount-payments" element={<DiscountPayments />} />
          <Route
            path="/discount-payments/:uid"
            element={<DiscountPayments />}
          />
        </Route>

        <Route element={<PrivateRoute path="/membership-cart-history" />}>
          <Route path="/membership-cart-history" element={<CartHistory />} />
        </Route>

        <Route element={<PrivateRoute path="/trainer-member-engagement" />}>
          <Route path="/trainer-member-engagement" element={<TMELogs />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-prospects" />}>
          <Route path="/pt-prospects" element={<PTProspectManagement />} />
        </Route>

        <Route element={<PrivateRoute path="/expense-categories" />}>
          <Route path="/expense-categories" element={<ExpenseCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/expense-process-managers" />}>
          <Route
            path="/expense-process-managers"
            element={<ExpenseProcessManagers />}
          />
        </Route>

        <Route element={<PrivateRoute path="/expense-management" />}>
          <Route path="/expense-management" element={<ExpenseManagement />} />
        </Route>

        <Route element={<PrivateRoute path="/referral" />}>
          <Route path="/referral" element={<Refferals />} />
        </Route>

        <Route element={<PrivateRoute path="/import-members" />}>
          <Route path="/import-members" element={<ImportMembersAdmin />} />
        </Route>

        <Route element={<PrivateRoute path="/attendance-report" />}>
          <Route path="/attendance-report" element={<AttendanceReport />} />
        </Route>

        <Route element={<PrivateRoute path="/late-checkins" />}>
          <Route path="/late-checkins" element={<LateCheckins />} />
        </Route>

        <Route element={<PrivateRoute path="/payouts" />}>
          <Route path="/payouts" element={<WTFPayouts />} />
        </Route>

        <Route element={<PrivateRoute path="/settlement-system" />}>
          <Route path="/settlement-system" element={<SettlementSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/centralized-plan" />}>
          <Route path="/centralized-plan" element={<Plans />} />
        </Route>

        <Route element={<PrivateRoute path="/centralized-plan-beta" />}>
          <Route path="/centralized-plan-beta" element={<CentralisedPlans />} />
        </Route>

        <Route element={<PrivateRoute path="/centralized-pt-plan-beta" />}>
          <Route path="/centralized-pt-plan-beta" element={<CentralisedPTPlans />} />
        </Route>

        <Route element={<PrivateRoute path="/pt-plans" />}>
          <Route path="/pt-plans" element={<PtPlansManage />} />
        </Route>

        <Route element={<PrivateRoute path="/cto" />}>
          <Route path="/cto" element={<CTOStats />} />
        </Route>

        <Route element={<PrivateRoute path="/keyword-actions" />}>
          <Route path="/keyword-actions" element={<KeywordActions />} />
        </Route>

        <Route element={<PrivateRoute path="/agent-mapping" />}>
          <Route path="/agent-mapping" element={<AgentMapping />} />
        </Route>

        <Route element={<PrivateRoute path="/campaign-logs" />}>
          <Route path="/campaign-logs" element={<CampaignSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/campaign-jobs" />}>
          <Route path="/campaign-jobs" element={<JobSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/voice-campaign" />}>
          <Route path="/voice-campaign" element={<VoiceoverSystem />}></Route>

          <Route element={<PrivateRoute path="/compose_voice_camping" />}>
            <Route path="/compose_voice_camping" element={<ComposeVC />} />
          </Route>
        </Route>

        <Route element={<PrivateRoute path="/leave-management" />}>
          <Route path="/leave-management" element={<LeaveManagement />} />
        </Route>

        <Route element={<PrivateRoute path="/hygiene-categories" />}>
          <Route path="/hygiene-categories" element={<HygieneCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/hygiene-tasks" />}>
          <Route path="/hygiene-tasks" element={<AllTasks />} />
        </Route>

        <Route element={<PrivateRoute path="/hygiene-manage" />}>
          <Route path="/hygiene-manage" element={<HygieneManagement />} />
        </Route>

        <Route element={<PrivateRoute path="/fitness-center" />}>
          <Route path="/fitness-center" element={<FitnessCenter />} />
        </Route>

        <Route element={<PrivateRoute path="/fitness-profile-logs" />}>
          <Route
            path="/fitness-profile-logs"
            element={<FitnessProfileLogs />}
          />
        </Route>

        <Route element={<PrivateRoute path="/health-tracking" />}>
          <Route path="/health-tracking" element={<HealthTracking />} />
        </Route>

        {/* WEBSITE CONTENT */}
        <Route element={<PrivateRoute path="/testimonial" />}>
          <Route path="/testimonial" element={<Testimonial />} />
        </Route>

        <Route element={<PrivateRoute path="/partners" />}>
          <Route path="/partners" element={<Partners />} />
        </Route>

        <Route element={<PrivateRoute path="/franchise-leads" />}>
          <Route path="/franchise-leads" element={<FranchiseLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/career" />}>
          <Route path="/career" element={<Career />} />
        </Route>

        <Route element={<PrivateRoute path="/offer-mapping" />}>
          <Route path="/offer-mapping" element={<OfferMapping />} />
        </Route>

        <Route element={<PrivateRoute path="/all-gym-offers" />}>
          <Route path="/all-gym-offers" element={<AllGymOffers />} />
        </Route>

        <Route element={<PrivateRoute path="/add-offers" />}>
          <Route path="/add-offers" element={<OfferAdding />} />
        </Route>

        <Route element={<PrivateRoute path="/tv-monitoring" />}>
          <Route path="/tv-monitoring" element={<TvMonitoringDashboard />} />
        </Route>

        <Route element={<PrivateRoute path="/wtf-banners" />}>
          <Route path="/wtf-banners" element={<WtfBanner />} />
        </Route>

        <Route element={<PrivateRoute path="/blog-categories" />}>
          <Route path="/blog-categories" element={<BlogCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/blogs" />}>
          <Route path="/blogs" element={<AdBlogs />} />
        </Route>
        {/* ---------------- WEBSITE CONTENT ---------------- */}

        {/* TV  */}
        <Route element={<PrivateRoute path="/tv" />}>
          <Route path="/tv" element={<Tv />} />
        </Route>

        <Route element={<PrivateRoute path="/tv-notifications" />}>
          <Route path="/tv-notifications" element={<TvNotification />} />
        </Route>
        {/* --------------TV-------------  */}

        {/* DIET */}
        <Route element={<PrivateRoute path="/diet-meal" />}>
          <Route path="/diet-meal" element={<DietMeals />} />
        </Route>

        <Route element={<PrivateRoute path="/ingredients" />}>
          <Route path="/ingredients" element={<Ingredients />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-unit" />}>
          <Route path="/diet-unit" element={<DietUnit />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-timing" />}>
          <Route path="/diet-timing" element={<DietTimings />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-type" />}>
          <Route path="/diet-type" element={<DietType />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-package" />}>
          <Route path="/diet-package" element={<DietPackage />} />
        </Route>

        <Route element={<PrivateRoute path="/fitness-profile" />}>
          <Route path="/fitness-profile" element={<FitnessProfile />} />
        </Route>

        <Route element={<PrivateRoute path="/dietician" />}>
          <Route path="/dietician" element={<Dieticians />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-plan" />}>
          <Route path="/diet-plan" element={<DietPlan />} />
        </Route>

        <Route element={<PrivateRoute path="/diet-dashboard" />}>
          <Route path="/diet-dashboard" element={<DietDashboard />} />
        </Route>

        <Route element={<PrivateRoute path="/btl-vendor" />}>
          <Route path="/btl-vendor" element={<BTLVendor />} />
        </Route>
        {/* ------------- DIET ----------------- */}

        <Route element={<PrivateRoute path="/raw-lead" />}>
          <Route path="/raw-lead" element={<RawLead />} />
        </Route>

        <Route element={<PrivateRoute path="/lms-beta" />}>
          <Route path="/lms-beta" element={<LMSBeta />} />
        </Route>

        {/* <Route element={<PrivateRoute path="/lms-report" />}>
          <Route path="/lms-report" element={<LeadReports />} />
        </Route> */}

        <Route element={<PrivateRoute path="/lms-closure-report" />}>
          <Route path="/lms-closure-report" element={<LMSClosureReport />} />
        </Route>

        <Route element={<PrivateRoute path="/lead-management" />}>
          <Route path="/lead-management" element={<LeadManagement />} />
        </Route>

        <Route element={<PrivateRoute path="/lead-analytics-gymwise" />}>
          <Route path="/lead-analytics-gymwise" element={<LeadAnalyticsGymwise />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-visit-analytics" />}>
          <Route path="/gym-visit-analytics" element={<GymVisitAnalytics />} />
        </Route>

        <Route element={<PrivateRoute path="/whats-new" />}>
          <Route path="/whats-new" element={<WhatsNew />} />
        </Route>

        <Route element={<PrivateRoute path="/lead-management/followup-analytics" />}>
          <Route path="/lead-management/followup-analytics" element={<FollowupAnalyticsPage />} />
        </Route>

        <Route element={<PrivateRoute path="/fresh-lead" />}>
          <Route path="/fresh-lead" element={<FreshLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/pre-sale-gym-leads" />}>
          <Route path="/pre-sale-gym-leads" element={<PreSaleGymLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/lead-closure-report" />}>
          <Route path="/lead-closure-report" element={<LeadClosureReport />} />
        </Route>

        <Route element={<PrivateRoute path="/upgrade-membership" />}>
          <Route path="/upgrade-membership" element={<UpgradeMembership />} />
        </Route>

        <Route element={<PrivateRoute path="/upgrade-pt-membership" />}>
          <Route path="/upgrade-pt-membership" element={<UpgradePtMembership />} />
        </Route>

        {/* <Route element={<PrivateRoute path="/time-sheet" />}>
          <Route path="/time-sheet" element={<TimeSheet />} />
        </Route> */}

        <Route element={<PrivateRoute path="/dashboard-docs" />}>
          <Route path="/dashboard-docs" element={<Docs />} />
          <Route path="/dashboard-docs/:uid" element={<Docs />} />
        </Route>

        <Route element={<PrivateRoute path="/fd-targets" />}>
          <Route path="/fd-targets" element={<FDTargets />} />
        </Route>

        <Route element={<PrivateRoute path="/daily-sales" />}>
          <Route path="/daily-sales" element={<DateSaleReport />} />
        </Route>

        <Route element={<PrivateRoute path="/fd-trainer-sales" />}>
          <Route path="/fd-trainer-sales" element={<FDTrainersSale />} />
        </Route>

        <Route element={<PrivateRoute path="/task-sop" />}>
          <Route path="/task-sop" element={<TaskSOP />} />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-checklist-status" />}
        >
          <Route
            path="/daily-operation-checklist-status"
            element={<HygieneCategories />}
          />
        </Route>

        <Route element={<PrivateRoute path="/hygine-task-frequency" />}>
          <Route
            path="/hygine-task-frequency"
            element={<HygineTaskFrequency />}
          />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-task-categories" />}
        >
          <Route
            path="/daily-operation-task-categories"
            element={<HygieneTaskCategories />}
          />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-checklist-tasks" />}
        >
          <Route
            path="/daily-operation-checklist-tasks"
            element={<AllTasks />}
          />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-checklist-form" />}
        >
          <Route
            path="/daily-operation-checklist-form"
            element={<HygineForm />}
          />
        </Route>

        <Route element={<PrivateRoute path="/daily-operation-checklist" />}>
          <Route
            path="/daily-operation-checklist"
            element={<HygineSubmittedTasks />}
          />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-checklist-gymwise" />}
        >
          <Route
            path="/daily-operation-checklist-gymwise"
            element={<HygineGymwise />}
          />
        </Route>

        <Route
          element={<PrivateRoute path="/daily-operation-checklist-approval" />}
        >
          <Route
            path="/daily-operation-checklist-approval"
            element={<HygineTaskApproval />}
          />
        </Route>

        <Route element={<PrivateRoute path="/hygiene-command-center" />}>
          <Route
            path="/hygiene-command-center"
            element={<HygieneCommandCenter />}
          />
        </Route>

        <Route element={<PrivateRoute path="/trainers" />}>
          <Route path="/trainers" element={<TrainerPage />} />
        </Route>

        <Route element={<PrivateRoute path="/version" />}>
          <Route path="/version" element={<Version />} />
        </Route>

        <Route element={<PrivateRoute path="/staff-onboarding-requests" />}>
          <Route
            path="/staff-onboarding-requests"
            element={<OnboardedStaff />}
          />
        </Route>

        <Route element={<PrivateRoute path="/housekeeping-on-board" />}>
          <Route
            path="/housekeeping-on-board"
            element={<HousekeepingOnboard />}
          />
        </Route>

        <Route element={<PrivateRoute path="/gallery" />}>
          <Route path="/gallery" element={<Gallery />} />
        </Route>

        <Route element={<PrivateRoute path="/wtf-benefits" />}>
          <Route path="/wtf-benefits" element={<WtfBenefits />} />
        </Route>

        <Route element={<PrivateRoute path="/feature-grouping" />}>
          <Route path="/feature-grouping" element={<DashFeatureGrouping />} />
        </Route>

        <Route element={<PrivateRoute path="/notification" />}>
          <Route path="/notification" element={<Notification />} />
        </Route>

        <Route element={<PrivateRoute path="/receptionists" />}>
          <Route path="/receptionists" element={<Receptionists />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-cities" />}>
          <Route path="/gym-cities" element={<GymCities />} />
        </Route>

        <Route element={<PrivateRoute path="/training" />}>
          <Route path="/training" element={<Training />} />
        </Route>

        <Route element={<PrivateRoute path="/couple-membership-request" />}>
          <Route path="/couple-membership-request" element={<DFApprovals />} />
        </Route>

        <Route element={<PrivateRoute path="/recurring-subscriptions" />}>
          <Route
            path="/recurring-subscriptions"
            element={<RecurringSubscriptions />}
          />
        </Route>

        <Route element={<PrivateRoute path="/reward-system" />}>
          <Route path="/reward-system" element={<RewardSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/feedbacks" />}>
          <Route path="/feedbacks" element={<GymFeedback />} />
        </Route>

        <Route element={<PrivateRoute path="/metabase-links" />}>
          <Route path="/metabase-links" element={<MetabaseLinks />} />
        </Route>

        <Route element={<PrivateRoute path="/dynamic-linking" />}>
          <Route path="/dynamic-linking" element={<DynamicLinkin />} />
        </Route>

        <Route element={<PrivateRoute path="/cash-reports" />}>
          <Route path="/cash-reports" element={<CashReports />} />
          <Route path="/cash-reports/:uid" element={<CashReports />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-landing-pages" />}>
          <Route path="/gym-landing-pages" element={<GymLandingListings />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-landing-details-pages" />}>
          <Route
            path="/gym-landing-details-pages"
            element={<GymLandingPages />}
          />
        </Route>

        <Route element={<PrivateRoute path="/website-tab-preferences" />}>
          <Route
            path="/website-tab-preferences"
            element={<WebsiteTabPreference />}
          />
        </Route>

        <Route element={<PrivateRoute path="/gym-categories" />}>
          <Route path="/gym-categories" element={<PlansCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/addons-categories" />}>
          <Route path="/addons-categories" element={<AddonsCategories />} />
        </Route>

        <Route element={<PrivateRoute path="/transfer" />}>
          <Route path="/transfer" element={<Transfer />} />
        </Route>

        <Route element={<PrivateRoute path="/pause-system" />}>
          <Route path="/pause-system" element={<PauseSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/pause-membership" />}>
          <Route path="/pause-membership" element={<PauseMembership />} />
        </Route>

        <Route element={<PrivateRoute path="/centralised-plan-categories" />}>
          <Route
            path="/centralised-plan-categories"
            element={<PlansCategories />}
          />
        </Route>

        <Route element={<PrivateRoute path="/academy-course-detail" />}>
          <Route path="/academy-course-detail" element={<AcademyCourses />} />
        </Route>

        <Route element={<PrivateRoute path="/academy-course-schedule" />}>
          <Route
            path="/academy-course-schedule"
            element={<AcademyCourseSchedule />}
          />
        </Route>

        <Route element={<PrivateRoute path="/wtf-investors" />}>
          <Route path="/wtf-investors" element={<WtfInvestors />} />
        </Route>

        <Route element={<PrivateRoute path="/wtf-team" />}>
          <Route path="/wtf-team" element={<WtfTeam />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-transfer" />}>
          <Route path="/gym-transfer" element={<GymTransferSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/membership-transfer" />}>
          <Route
            path="/membership-transfer"
            element={<MembershipTransferSystem />}
          />
        </Route>

        <Route element={<PrivateRoute path="/academy-course-detail" />}>
          <Route path="/academy-course-detail" element={<AcademyCourses />} />
        </Route>

        <Route element={<PrivateRoute path="/academy-course-schedule" />}>
          <Route
            path="/academy-course-schedule"
            element={<AcademyCourseSchedule />}
          />
        </Route>

        <Route element={<PrivateRoute path="/wtf-investors" />}>
          <Route path="/wtf-investors" element={<WtfInvestors />} />
        </Route>

        <Route element={<PrivateRoute path="/wtf-team" />}>
          <Route path="/wtf-team" element={<WtfTeam />} />
        </Route>

        <Route element={<PrivateRoute path="/broadcast-templates" />}>
          <Route path="/broadcast-templates" element={<Templates />} />
        </Route>

        <Route element={<PrivateRoute path="/broadcast-variables" />}>
          <Route path="/broadcast-variables" element={<Variables />} />
        </Route>

        <Route element={<PrivateRoute path="/sendy-campaign-lists" />}>
          <Route path="/sendy-campaign-lists" element={<SendyLists />} />
        </Route>

        <Route element={<PrivateRoute path="/broadcast-template" />}>
          <Route path="/broadcast-template" element={<BroadcastTemplate />} />
        </Route>

        <Route element={<PrivateRoute path="/broadcast-scheduler" />}>
          <Route path="/broadcast-scheduler" element={<BCAScheduler />} />
        </Route>

        <Route element={<PrivateRoute path="/scheduled-broadcast-logs" />}>
          <Route
            path="/scheduled-broadcast-logs"
            element={<BCAScheduledWatiLogs />}
          />
        </Route>

        {/* Email Broadcast System */}
        <Route
          element={<PrivateRoute path="/broadcast-system/email-broadcast" />}
        >
          <Route
            path="/broadcast-system/email-broadcast"
            element={<EmailBroadcastDashboard />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/lists" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/lists"
            element={<EmailLists />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/lists/:listId/subscribers" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/lists/:listId/subscribers"
            element={<EmailSubscribers />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/templates" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/templates"
            element={<EmailTemplates />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/campaigns" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/campaigns"
            element={<EmailCampaigns />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/campaigns/new" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/campaigns/new"
            element={<EmailCampaignForm />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/campaigns/:id" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/campaigns/:id"
            element={<EmailCampaignForm />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/campaigns/:id/edit" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/campaigns/:id/edit"
            element={<EmailCampaignForm />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/analytics" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/analytics"
            element={<EmailAnalytics />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute path="/broadcast-system/email-broadcast/suppression" />
          }
        >
          <Route
            path="/broadcast-system/email-broadcast/suppression"
            element={<EmailSuppression />}
          />
        </Route>

        {/* <Route element={<PrivateRoute path="/roaster-manager" />}>
          <Route path="/roaster-manager" element={<RoasterManager />} />
        </Route> */}

        <Route element={<PrivateRoute path="/payroll-processor" />}>
          <Route path="/payroll-processor" element={<PayroleProcessor />} />
        </Route>

        <Route element={<PrivateRoute path="/triggers" />}>
          <Route path="/triggers" element={<Triggers />} />
        </Route>

        <Route element={<PrivateRoute path="/inventories" />}>
          <Route path="/inventories" element={<Inventories />} />
        </Route>

        <Route element={<PrivateRoute path="/segments" />}>
          <Route path="/segments" element={<SegmentOfferMapping />} />
        </Route>

        <Route element={<PrivateRoute path="/payrole-processor" />}>
          <Route path="/payrole-processor" element={<PayroleProcessor />} />
        </Route>
        <Route element={<PrivateRoute path="/ticket-system" />}>
          <Route path="/ticket-system" element={<TicketSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/ticket-user-roles" />}>
          <Route path="/ticket-user-roles" element={<TicketUserRoles />} />
        </Route>

        <Route element={<PrivateRoute path="/ticket-category-management" />}>
          <Route
            path="/ticket-category-management"
            element={<TicketSystemManagement />}
          />
        </Route>

        <Route element={<PrivateRoute path="/sla-rules" />}>
          <Route path="/sla-rules" element={<SLARules />} />
        </Route>

        <Route element={<PrivateRoute path="/three-day-pt-trial" />}>
          <Route path="/three-day-pt-trial" element={<ThreeDayPTTrial />} />
        </Route>

        <Route element={<PrivateRoute path="/staff-profiles" />}>
          <Route path="/staff-profiles" element={<StaffProfiles />} />
        </Route>

        <Route element={<PrivateRoute path="/academy-leads" />}>
          <Route path="/academy-leads" element={<AcademyLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/gym-alias" />}>
          <Route path="/gym-alias" element={<GymAlias />} />
        </Route>

        <Route element={<PrivateRoute path="/subscription-extension" />}>
          <Route
            path="/subscription-extension"
            element={<SubscriptionExtension />}
          />
        </Route>

        <Route element={<PrivateRoute path="/live-subscriptions" />}>
          <Route path="/live-subscriptions" element={<LiveSubsciptions />} />
        </Route>

        <Route element={<PrivateRoute path="/live-bca-pending-logs" />}>
          <Route path="/live-bca-pending-logs" element={<LiveBCAPending />} />
        </Route>

        <Route element={<PrivateRoute path="/live-pt-trial-logs" />}>
          <Route path="/live-pt-trial-logs" element={<LivePTTrialPending />} />
        </Route>

        <Route element={<PrivateRoute path="/live-checkins" />}>
          <Route path="/live-checkins" element={<LiveMemberCheckins />} />
        </Route>

        <Route element={<PrivateRoute path="/live-renewal-reminder" />}>
          <Route
            path="/live-renewal-reminder"
            element={<LiveRenewalReminder />}
          />
        </Route>

        <Route element={<PrivateRoute path="/live-member-report" />}>
          <Route path="/live-member-report" element={<LiveMemberReport />} />
        </Route>

        <Route element={<PrivateRoute path="/tracking-system" />}>
          <Route path="/tracking-system" element={<TrackingSystem />} />
        </Route>

        <Route element={<PrivateRoute path="/fitness-coach-leads" />}>
          <Route path="/fitness-coach-leads" element={<FitnessCoachLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/amplify-leads" />}>
          <Route path="/amplify-leads" element={<AmplifyLeads />} />
        </Route>

        <Route element={<PrivateRoute path="/regularization" />}>
          <Route path="/regularization" element={<Regularization />} />
        </Route>

        <Route element={<PrivateRoute path="/essl-member-dump" />}>
          <Route path="/essl-member-dump" element={<ESSLMemberDump />} />
        </Route>

        <Route element={<PrivateRoute path="/wtf-360-consultations" />}>
          <Route
            path="/wtf-360-consultations"
            element={<WTF360Consultations />}
          />
        </Route>

        <Route element={<PrivateRoute path="/trainer-notification-logs" />}>
          <Route
            path="/trainer-notification-logs"
            element={<TrainerNotificationLogs />}
          />
        </Route>

        <Route element={<PrivateRoute path="/chat-history" />}>
          <Route path="/chat-history" element={<ChatHistory />} />
        </Route>

        <Route element={<PrivateRoute path="/fd-incentives" />}>
          <Route path="/fd-incentives" element={<FDIncentives />} />
        </Route>

        <Route element={<PrivateRoute path="/lead-call-logs" />}>
          <Route path="/lead-call-logs" element={<CallLogs />} />
        </Route>
      </Route>

      <Route element={<SuspenseWrapper />}>
        <Route path="/cash-verify/:token" element={<CashVerificationPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<UnAuthorized />} />
        <Route path="/subscriptions" element={<SubscriptionDetails />} />
        <Route path="/enquiry" element={<EnquiryFormPage />} />
        <Route path="/testing-numbers" element={<TestingNumbers />} />
        <Route path="/open-access" element={<CommonOpenPage />} />
        <Route path="/open-access/all-pages" element={<OpenPages />} />
        <Route
          path="/open-access/all-pages/pt-trial-registration"
          element={<PTTrackOpenForm />}
        />
        <Route
          path="/open-access/all-pages/import-members"
          element={<ImportMembersOpen />}
        />
        <Route
          path="/open-access/all-pages/all-leaves"
          element={<StaffLeaveManagement />}
        />
        <Route
          path="/open-access/all-pages/approve-leaves"
          element={<ApprovalManager />}
        />
        <Route
          path="/open-access/all-pages/lead-and-followup-management"
          element={<LeadManagementOpen />}
        />
        <Route
          path="/open-access/all-pages/pending-partial-payments"
          element={<PMLinkOpenPage />}
        />
        <Route
          path="/open-access/all-pages/renewal-expiring-unpaid-members"
          element={<UREOpen />}
        />
        <Route
          path="/open-access/all-pages/membership-requests"
          element={<CuponRequestOpen />}
        />
        <Route
          path="/open-access/all-pages/trainer-member-engagement"
          element={<TrainerMemberEngagement />}
        />
        <Route
          path="/open-access/all-pages/one-day-membership"
          element={<OneDayMembershipOpen />}
        />
        <Route
          path="/open-access/all-pages/pt-prospects"
          element={<PTProspectManagementOpen />}
        />
        <Route
          path="/open-access/all-pages/deffered-payments"
          element={<DefferedPaymentsOpen />}
        />
        <Route
          path="/open-access/all-pages/discount-payments"
          element={<DiscountPaymentsOpen />}
        />
        <Route
          path="/open-access/all-pages/expense-management"
          element={<ExpenseManagementOpen />}
        />
        <Route
          path="/open-access/all-pages/trainer-incentives"
          element={<TrainerIncentivesOpen />}
        />
        <Route
          path="/open-access/all-pages/upgrade-membership"
          element={<UpgradeMembershipOpen />}
        />

        <Route
          path="/open-access/all-pages/time-sheet"
          element={<TimeSheetOpen />}
        />

        <Route
          path="/open-access/all-pages/dashboard-docs"
          element={<DocsOpen />}
        />
        <Route
          path="/open-access/all-pages/dashboard-docs/:uid"
          element={<DocsOpen />}
        />

        <Route
          path="/open-access/all-pages/daily-operation-checklist"
          element={<HygineSubmittedTasksOpen />}
        />

        <Route
          path="/open-access/all-pages/daily-operation-checklist-approval"
          element={<HygineTaskApprovalOpen />}
        />

        <Route
          path="/open-access/all-pages/gym-plans"
          element={<GymPlansOpen />}
        />

        <Route
          path="/daily-operation-checklist-form-open"
          element={<HygineOpenForm />}
        />

        <Route path="/staff-on-board" element={<OnBoardingForm />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </CurrencyProvider>
  );
};

export default App;
